import { Vector3 } from 'three';

const COLORS = {
  normal: '#ffffff',
  crit: '#ffd166',
  freeze: '#77e7ff',
  self: '#ff4f68',
};

const temp = new Vector3();
let state = null;

export function initDamageNumbers(options = {}) {
  const root = options.root || document.getElementById('labelLayer') || document.body;
  const pool = [];
  for (let i = 0; i < 64; i += 1) {
    const element = document.createElement('span');
    element.className = 'floating-label damage-number';
    Object.assign(element.style, {
      opacity: '0',
      transform: 'translate3d(-999px,-999px,0)',
      color: COLORS.normal,
      fontSize: '18px',
      pointerEvents: 'none',
    });
    root.appendChild(element);
    pool.push({ element, active: false, age: 0, ttl: 0.8, worldPos: new Vector3(), type: 'normal', spreadX: 0, spreadY: 0 });
  }
  state = { root, pool, cursor: 0 };
  injectDamageNumberStyles();
  return state;
}

export function spawnDamageNumber(worldPos, amount, type = 'normal', camera = null, options = {}) {
  if (!state) initDamageNumbers();
  const item = state.pool[state.cursor];
  state.cursor = (state.cursor + 1) % state.pool.length;
  item.active = true;
  item.age = 0;
  item.ttl = options.killed ? 1.05 : type === 'crit' ? 0.94 : 0.78;
  item.type = type;
  item.spreadX = (Math.random() - 0.5) * (options.killed ? 46 : 26);
  item.spreadY = -Math.random() * 18;
  item.worldPos.copy(worldPos);
  const fallback = amount == null ? (options.label || '') : `${options.label ? `${options.label} ` : ''}${Math.round(amount)}`;
  item.element.textContent = options.text || fallback;
  item.element.className = `floating-label damage-number ${type}${options.killed ? ' killed' : ''}`;
  item.element.style.color = COLORS[type] || COLORS.normal;
  item.element.style.fontSize = options.killed ? '34px' : type === 'crit' ? '28px' : '20px';
  item.element.style.opacity = '1';
  if (camera) positionDamageNumber(item, camera);
}

export function updateDamageNumbers(dt, camera) {
  if (!state || !camera) return;
  for (const item of state.pool) {
    if (!item.active) continue;
    item.age += dt;
    if (item.age >= item.ttl) {
      item.active = false;
      item.element.style.opacity = '0';
      item.element.style.transform = 'translate3d(-999px,-999px,0)';
      continue;
    }
    positionDamageNumber(item, camera);
  }
}

function positionDamageNumber(item, camera) {
  temp.copy(item.worldPos);
  temp.y += 1.45;
  temp.project(camera);
  if (temp.z < -1 || temp.z > 1) {
    item.element.style.opacity = '0';
    return;
  }
  const x = (temp.x * 0.5 + 0.5) * window.innerWidth;
  const y = (-temp.y * 0.5 + 0.5) * window.innerHeight;
  const t = item.age / item.ttl;
  const lift = -56 * Math.min(1, t / 0.7) + item.spreadY;
  const fade = t < 0.62 ? 1 : Math.max(0, 1 - (t - 0.62) / 0.38);
  const pop = t < 0.12 ? 0.65 + t / 0.12 * 0.55 : 1 + Math.max(0, 1 - t) * (item.type === 'crit' ? 0.18 : 0.08);
  const scale = item.element.classList.contains('killed') ? pop * 1.12 : pop;
  item.element.style.opacity = String(fade);
  item.element.style.transform = `translate3d(${x + item.spreadX * t}px,${y + lift}px,0) translate(-50%,-50%) rotate(${-5 + t * 8}deg) scale(${scale})`;
}

function injectDamageNumberStyles() {
  if (document.getElementById('damageNumberStyles')) return;
  const style = document.createElement('style');
  style.id = 'damageNumberStyles';
  style.textContent = `
    .damage-number {
      font-family:"Black Ops One","Orbitron","Rajdhani",sans-serif;
      font-weight:900; letter-spacing:0; white-space:nowrap;
      -webkit-text-stroke:1px rgba(2,5,10,.72);
      text-shadow:0 2px 0 rgba(0,0,0,.72),0 0 16px currentColor,0 0 34px rgba(255,255,255,.16);
      filter:drop-shadow(0 8px 14px rgba(0,0,0,.45));
      will-change:transform,opacity;
    }
    .damage-number.crit { -webkit-text-stroke-color:rgba(70,30,0,.82); }
    .damage-number.freeze { text-shadow:0 2px 0 rgba(0,18,28,.8),0 0 18px #77e7ff,0 0 42px rgba(119,231,255,.35); }
    .damage-number.self { -webkit-text-stroke-color:rgba(50,0,9,.84); }
    .damage-number.killed {
      color:#ffd166;
      text-shadow:0 2px 0 rgba(55,22,0,.82),0 0 18px #ffd166,0 0 46px rgba(255,209,102,.5);
    }
  `;
  document.head.appendChild(style);
}
